/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Tpl_BackInputs */

const en_fw_tpl_back = /** @type {(inputs: Fw_Tpl_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All templates`)
};

const id_fw_tpl_back = /** @type {(inputs: Fw_Tpl_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua template`)
};

/**
* | output |
* | --- |
* | "All templates" |
*
* @param {Fw_Tpl_BackInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_tpl_back = /** @type {((inputs?: Fw_Tpl_BackInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Tpl_BackInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_tpl_back(inputs)
	return en_fw_tpl_back(inputs)
});